import React from 'react';
import '../styles/App.css';
import Sidebar from '../components/sidemenu/sidebar';
import CrudTable from '../components/cruds/table_POLIZAS';

const polizas = () => {
  return (
    <div>
        <Sidebar/>
        <div>
            <h3 className="title">Gestión Pólizas</h3>
        </div>
        <CrudTable/>
    </div>
  );


};

export default polizas;